import React from "react";
import styled from "styled-components";
import Spinner from "../../../components/Spinner";
import { primaryColor } from "../../../constants/colors";

const DescribeProblem = ({ value, onChange, readOnly }) => {
  return (
    <Wrapper className="px-3 py-2">
      <p className="txt">Explain Your Problem Briefly</p>
      {readOnly ? (
        <div className="bg-grey2 px-2 py-2 rounded text-grey2">{value}</div>
      ) : (
        <div className="problemField rounded">
          <textarea className="rounded bg-grey2" rows={5} type="text" value={value} onChange={onChange} placeholder="Enter here...">
            {value}
          </textarea>
        </div>
      )}
    </Wrapper>
  );
};

export default DescribeProblem;

const Wrapper = styled.div`
  .appointmenttype {
    overflow-x: scroll;
  }
  .problemField {
    width: 100%;

    outline: none;
    border: none;
    textarea {
      border: none;
      outline: none;

      width: 100%;
      padding: 12px;
      color: gray;
      font-size: 0.95;
      &::placeholder {
        color: gray;
      }
    }
  }
  .txt {
    color: gray;
  }
  p {
    margin-bottom: 0.4rem;
  }
`;
